module.exports = __webpack_public_path__ + "static/img/w2.561dc0ec.png";